import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  IState,
} from '../models/IState/IState';
import { API_BASE_URL } from '../helpers/common';

export const statesApi = createApi({
  reducerPath: 'statesApi',
  tagTypes: ['State'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getStates: build.query<IState[], void>({
      transformResponse: (response: { data: IState[] }) => response.data,
      query: () => ({
        url: '/states/list',
        method: 'GET',
      }),
    }),

    getStateById: build.query<IState, number>({
      transformResponse: (response: { data: IState }) => response.data,
      query: (id) => ({
        url: `/states/${id}`,
        method: 'GET',
      }),
    })
  }),
});

export const {
  useGetStatesQuery,
  useGetStateByIdQuery,
} = statesApi;
